
(function(){
  document.addEventListener('click', function(e){
    var l = e.target.closest('.langsel a[data-lang]');
    if(l){ e.preventDefault(); var f=document.getElementById('LangForm'); if(f){ f.querySelector('input[name=locale_code]').value=l.getAttribute('data-lang'); f.submit(); } return; }
    var t = e.target.closest('.pack');
    if(t){
      var form = t.closest('form') || document;
      form.querySelectorAll('.pack').forEach(function(p){p.classList.remove('sel');});
      t.classList.add('sel');
      var r = t.querySelector('input'); if(r) r.checked = true;
      var price = t.getAttribute('data-price'), was = t.getAttribute('data-was');
      document.querySelectorAll('[data-live-price]').forEach(function(el){ el.textContent = price; });
      document.querySelectorAll('[data-live-was]').forEach(function(el){ el.textContent = was; });
    }
    var th = e.target.closest('.galthumbs img');
    if(th){
      var main = document.getElementById('galmain');
      if(main){ main.src = th.getAttribute('data-full') || th.src; }
      document.querySelectorAll('.galthumbs img').forEach(function(i){i.classList.remove('on');});
      th.classList.add('on');
    }
  });
  document.querySelectorAll('.ba').forEach(function(b){
    var range=b.querySelector('input[type=range]'), after=b.querySelector('.after'), handle=b.querySelector('.handle'), knob=b.querySelector('.knob');
    function set(v){ after.style.clipPath='inset(0 0 0 '+v+'%)'; handle.style.left=v+'%'; knob.style.left=v+'%'; }
    if(range){ range.addEventListener('input', function(){ set(range.value); }); set(range.value); }
  });
  document.querySelectorAll('form[data-cart-form] input[name^="updates"]').forEach(function(i){ i.addEventListener('change', function(){ i.form.submit(); }); });
})();


(function(){
  var drawer=document.getElementById('cartDrawer'), scrim=document.getElementById('drawerScrim'), lines=document.getElementById('drawerLines'), total=document.getElementById('drawerTotal');
  if(!drawer||!window.fetch) return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var L=drawer.dataset;
  function money(c){ return '€'+(c/100).toFixed(2).replace('.',','); }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];}); }
  // DRAWER MERGE PATCH: one row per variant even when Shopify splits the lines for a discount
  function groups(cart){
    var g=[], byId={};
    cart.items.forEach(function(it,i){
      var gift = it.final_line_price===0 && it.original_line_price>0;
      var key = gift ? 'gift'+i : String(it.variant_id);
      var row = byId[key];
      if(!row){ row={key:key, gift:gift, it:it, quantity:0, final:0, original:0, lines:[]}; byId[key]=row; g.push(row); }
      row.quantity+=it.quantity; row.final+=it.final_line_price; row.original+=it.original_line_price; row.lines.push((i+1)+':'+it.quantity);
    });
    return g;
  }
  function render(cart, addedTitle){
    var h='';
    if(addedTitle) h+='<div class="drawer-added">'+esc(L.lAdded)+'</div>';
    if(!cart.items.length) h+='<div class="drawer-empty">'+esc(L.lEmpty)+'</div>';
    groups(cart).forEach(function(r){
      var it=r.it, img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/,'_160x160$1$2') : '';
      h+='<div class="dl" data-vid="'+it.variant_id+'" data-lines="'+r.lines.join(',')+'">'+(img?'<img src="'+esc(img)+'" alt="">':'<span style="width:64px"></span>')+
         '<div class="t"><b>'+esc(it.product_title)+'</b>'+(it.variant_title&&it.variant_title!=='Default Title'?'<span>'+esc(it.variant_title)+'</span>':'')+
         (r.gift?'':'<div class="q"><button type="button" data-d="-1" aria-label="-">&minus;</button><i>'+r.quantity+'</i><button type="button" data-d="1" aria-label="+">+</button><a data-rm="1">'+esc(L.lRemove)+'</a></div>')+
         '</div><div class="p">'+(r.gift?'<em>'+esc(L.lGift)+'</em>'+money(0)+'<s>'+money(r.original)+'</s>':money(r.final)+(r.final<r.original?'<s>'+money(r.original)+'</s>':''))+'</div></div>';
    });
    (cart.cart_level_discount_applications||[]).forEach(function(dd){ h+='<div class="dl dl-disc"><span style="width:64px"></span><div class="t"><b>'+esc(L.lDisc||'')+'</b></div><div class="p">&minus;'+money(dd.total_allocated_amount)+'</div></div>'; });
    lines.innerHTML=h; total.textContent=money(cart.total_price);
    document.querySelectorAll('.cartbtn').forEach(function(b){ var t=b.childNodes; for(var k=t.length-1;k>=0;k--){ if(t[k].nodeType===3){ t[k].nodeValue=' '+L.lCart+(cart.item_count>0?' ('+cart.item_count+')':''); break; } } });
  }
  function open(cart, addedTitle){ render(cart, addedTitle); scrim.hidden=false; drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.documentElement.classList.add('drawer-open'); }
  function close(){ drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); scrim.hidden=true; document.documentElement.classList.remove('drawer-open'); }
  function getCart(){ return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function post(path, body){ return fetch(root+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){ if(!r.ok) throw r; return r.json(); }); }
  var KIT=drawer.getAttribute('data-kit'), GIFT=drawer.getAttribute('data-gift');
  function autoN(v){ try{ if(v!==undefined) sessionStorage.setItem('dvGiftAuto', String(v)); return parseInt(sessionStorage.getItem('dvGiftAuto')||'0',10)||0; }catch(err){ return 0; } }
  function syncGift(c){
    if(!KIT||!GIFT) return Promise.resolve(c);
    var kits=0, packs=0; c.items.forEach(function(it){ if(String(it.variant_id)===KIT) kits+=it.quantity; if(String(it.variant_id)===GIFT) packs+=it.quantity; });
    var target=Math.min(kits,2), auto=Math.min(autoN(), packs);
    if(packs<target){ autoN(auto+target-packs); return post('cart/add.js',{items:[{id:parseInt(GIFT,10), quantity:target-packs}]}).then(getCart); }
    if(auto>target){
      var idx=-1, best=null;
      c.items.forEach(function(it,i){ if(String(it.variant_id)===GIFT && (best===null || it.final_line_price>best.final_line_price)){ best=it; idx=i; } });
      if(idx<0) return Promise.resolve(c);
      autoN(auto-1);
      return post('cart/change.js',{line:idx+1, quantity:best.quantity-1}).then(getCart).then(syncGift);
    }
    return Promise.resolve(c);
  }
  document.getElementById('drawerClose').addEventListener('click', close);
  document.getElementById('drawerContinue').addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  lines.addEventListener('click', function(e){
    var row=e.target.closest('.dl'); if(!row) return;
    var d=e.target.closest('button[data-d]'), rm=e.target.closest('a[data-rm]'); if(!d&&!rm) return;
    var vid=parseInt(row.getAttribute('data-vid'),10);
    var ls=row.getAttribute('data-lines').split(',').map(function(x){ var p=x.split(':'); return {line:parseInt(p[0],10), quantity:parseInt(p[1],10)}; }).sort(function(x,y){ return y.line-x.line; });
    var p;
    if(d && d.getAttribute('data-d')==='1'){ p=post('cart/add.js',{items:[{id:vid, quantity:1}]}); }
    else if(rm){ p=ls.reduce(function(acc,l){ return acc.then(function(){ return post('cart/change.js',{line:l.line, quantity:0}); }); }, Promise.resolve()); }
    else { p=post('cart/change.js',{line:ls[0].line, quantity:ls[0].quantity-1}); }
    p.then(getCart).then(syncGift).then(function(cc){ render(cc); }).catch(function(){ window.location.href=root+'cart'; });
  });
  document.querySelectorAll('.cartbtn').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); getCart().then(function(c){ open(c); }).catch(function(){ window.location.href=b.href; }); }); });
  // every add-to-cart form: add (plus the free 5-pack once, when the form carries it), then open the drawer
  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      var idEl=form.querySelector('input[name=id]:checked')||form.querySelector('input[name=id]'); if(!idEl) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var gift=form.getAttribute('data-gift-variant'); var main={id:parseInt(idEl.value,10), quantity:parseInt(idEl.getAttribute('data-qty')||'1',10)};
      post('cart/add.js',{items:[main]}).then(getCart).then(function(c){ return gift ? syncGift(c) : c; }).then(function(c){ open(c, true); }).catch(function(){ form.removeAttribute('data-gift-variant'); form.submit(); });
    }, true);
  });
})();



(()=>{const dialog=document.querySelector('.photo-viewer');if(!dialog)return;
const picture=dialog.querySelector('img'),caption=dialog.querySelector('figcaption');
let group=[],index=0,opener=null;
function show(i){index=(i+group.length)%group.length;const item=group[index];picture.src=item.dataset.photo;picture.alt=item.dataset.photoTitle;caption.textContent=item.dataset.photoTitle;dialog.querySelectorAll('.viewer-arrow').forEach(b=>b.hidden=group.length<2);}
document.querySelectorAll('[data-photo]').forEach(button=>button.addEventListener('click',()=>{opener=button;group=Array.from(document.querySelectorAll('[data-photo]')).filter(b=>b.dataset.photoGroup===button.dataset.photoGroup);show(group.indexOf(button));dialog.showModal();}));
dialog.querySelector('.viewer-close').addEventListener('click',()=>dialog.close());
dialog.querySelector('.viewer-prev').addEventListener('click',()=>show(index-1));
dialog.querySelector('.viewer-next').addEventListener('click',()=>show(index+1));
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(index+1)}if(e.key==='ArrowLeft'){e.preventDefault();show(index-1)}});
dialog.addEventListener('close',()=>{picture.removeAttribute('src');if(opener)opener.focus({preventScroll:true});});
})();


(function(){
  // (gift ride-along now lives in the drawer handler)
  document.addEventListener('click', function(e){
    var th = e.target.closest('.galthumbs img');
    if(th){ var b = document.querySelector('.gal .photo-open'); if(b){ b.setAttribute('data-photo', th.getAttribute('data-full') || th.src); b.setAttribute('data-photo-title', th.getAttribute('alt') || ''); } }
    var p = e.target.closest('.pack');
    if(p){ var sv = p.getAttribute('data-save') || ''; var wasv = p.getAttribute('data-was') || '';
      document.querySelectorAll('[data-live-save]').forEach(function(el){ if(sv){ el.hidden=false; el.innerHTML='&minus;&nbsp;'+sv+'&nbsp;%'; } else { el.hidden=true; el.textContent=''; } });
      document.querySelectorAll('[data-live-launch]').forEach(function(el){ el.hidden = !wasv; });
      document.querySelectorAll('[data-live-was]').forEach(function(el){ el.textContent = wasv; }); }
  });
})();

